import { Container } from '@/components';
import React, { useState, useRef } from 'react';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import { useMarginCalculator } from '@/context/marginCalculatorContext/MarginCalculatorContextProvider';
import { FaFileCsv } from 'react-icons/fa'; // Import React icon

const LoadFile = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { uploadMarginCalculationFile, downloadCSV, downloadExcel } =
    useMarginCalculator();
  const fileUploadRef = useRef(null);

  const handleFilesSelected = (files) => {
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length > 0) {
      await uploadMarginCalculationFile(files[0]);
      fileUploadRef.current.clearFiles();
    }
  };

  return (
    <Container title={'Load / Download Product File'}>
      <div className="bg-white rounded-lg max-w-lg min-w-full">
        {/* Heading */}
        <div className="flex justify-center">
          <div>
            <p className="text-gray-500 mb-6 text-center">
              Please upload a CSV file containing product data.
            </p>
            {/* File Upload */}
            <FileUploadTemplate
              ref={fileUploadRef}
              maxFiles={1}
              acceptedFileTypes={['.csv']}
              onFilesSelected={handleFilesSelected}
              onUpload={handleUpload}
            />

            {/* Buttons */}
            {/* <div className="flex justify-center mx-6">
              <button
                className="w-96 bg-blue-500 hover:bg-blue-700 text-white py-2 rounded-lg transition mb-4 flex items-center justify-center"
                onClick={downloadExcel}
              >
                <FaFileExcel className="w-5 h-5 mr-2" /> Download Excel
              </button>
            </div> */}
            <div className="flex justify-center mx-6">
              <button
                className="w-96 bg-green-400 hover:bg-green-700 text-white py-2 rounded-lg transition mb-4 flex items-center justify-center"
                onClick={downloadCSV}
              >
                <FaFileCsv className="w-5 h-5 mr-2" /> Download CSV
              </button>
            </div>
          </div>
        </div>

        {/* Error or Instruction Message */}
        <p className="text-center text-red-500 text-sm mb-4">
          * Note: The file should be in the following format.
        </p>

        {/* Table */}
        <div className="overflow-x-auto rounded-lg bg-gray-50 m-5 border">
          <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
            <thead className="bg-gray-100">
              <tr className="">
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Group
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Group Name
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Minor Category
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Cost
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Concat
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  GP 1
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  GP 2
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  GP 3
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  GP 4
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Qty 1
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Qty 2
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Qty 3
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  BCC Price
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  UNSP
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Warehouse
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Bin Location
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  ABC Class
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Buyer Planner
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {/* Empty rows */}
              {Array.from({ length: 2 }).map((_, index) => (
                <tr key={index}>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LoadFile;
